import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { Service } from '../service';
import { IndexCardConfiguration } from '../../models/index-card-configuration/index-card-configuration';
import { Observable } from 'rxjs/Observable';
import { AddStudentDto } from '../../models/students/dto/AddStudentDto';

@Injectable()
export class IndexCardConfigurationService extends Service {
    constructor(
        private http: HttpClientService
    ) {
        super();
    }

    public get(): Observable<IndexCardConfiguration> {
        const url = 'indexcardconfiguration';
        return this.http.get(url).map(response => {
            const r = response.json();
            let result = new IndexCardConfiguration();
            if (r.ResultCode === 1) {
                result = r.Result;
            } else {
                console.error('StudentService > getAll > response', r);
            }
            return result;
        }).catch(this.handleError);
    }

    public edit(indexCardConfiguration: IndexCardConfiguration) {
        const url = 'indexcardconfiguration';
        return this.http.post(url, indexCardConfiguration).map(response => response.json())
            .catch(this.handleError);
    }

    public add(config: IndexCardConfiguration) {
        const url = 'indexcardconfiguration';
        return this.http.post(url, config).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/index-card-configuration/index-card-configuration.service.ts